<script setup lang="ts">
import { DialogClose, DialogContent, DialogPortal, DialogRoot, DialogTrigger } from "reka-ui";
</script>

<template>
  <DialogRoot>
    <DialogTrigger class="focus-default flex items-center justify-center gap-1.5 rounded bg-light px-3 py-2 text-xl font-semibold">
      Afficher les filtres
    </DialogTrigger>
    <DialogPortal>
      <UiDialogOverlay />
      <DialogContent class="animation-fade color-white wp-top-0 wp-max-h-screen fixed inset-y-0 left-0 w-full overflow-y-scroll p-4 sm:w-menuMobile">
        <ShopFilters>
          <template #close>
            <DialogClose class="flex shrink-0" aria-label="Fermer">
              <span class="i-local-x size-8" aria-hidden="true" />
            </DialogClose>
          </template>
        </ShopFilters>
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>
